const query = `query GetNavData {
	collection(handle: "code_of_practice") {
	  structure {
		tree {
		  page {
			id
			title
			url
			slug
			collection {
			  handle
			}
			... on Entry_CodeOfPractice_Chapter {
			  active
			  theme {
				value
			  }
			}
			... on Entry_CodeOfPractice_SectionOverview {
			  active
			}
			... on Entry_CodeOfPractice_KeyHeading {
			  active
			}
			... on Entry_CodeOfPractice_Section {
			  active
			}
			... on Entry_CodeOfPractice_SubHeading {
			  active
			}
		  }
		  children {
			page {
			  url
			  title
			  slug
			  id
			  ... on Entry_CodeOfPractice_Chapter {
				active
			  }
			  ... on Entry_CodeOfPractice_SectionOverview {
				active
			  }
			  ... on Entry_CodeOfPractice_KeyHeading {
				active
			  }
			  ... on Entry_CodeOfPractice_Section {
				active
			  }
			  ... on Entry_CodeOfPractice_SubHeading {
				active
			  }
			}
			children {
			  page {
				url
				title
				slug
				id
				... on Entry_CodeOfPractice_Chapter {
				  active
				}
				... on Entry_CodeOfPractice_SectionOverview {
				  active
				}
				... on Entry_CodeOfPractice_KeyHeading {
				  active
				}
				... on Entry_CodeOfPractice_Section {
				  active
				}
				... on Entry_CodeOfPractice_SubHeading {
				  active
				}
			  }
			  children {
				page {
				  url
				  id
				  title
				  slug
				  ... on Entry_CodeOfPractice_Chapter {
					active
				  }
				  ... on Entry_CodeOfPractice_SectionOverview {
					active
				  }
				  ... on Entry_CodeOfPractice_KeyHeading {
					active
				  }
				  ... on Entry_CodeOfPractice_Section {
					active
				  }
				  ... on Entry_CodeOfPractice_SubHeading {
					active
				  }
				}
			  }
			}
		  }
		}
	  }
	}
	nav(handle: "main") {
	  tree {
		page {
		  entry_id
		  url
		  title
		}
	  }
	}
  }`
export default query